import { observable, action } from "mobx";

export function createPassportModalState() {
    return observable({
        openModal: false,
        passportInfo: null,
        passportCache: {},
        passportLoading: false,

        open: action(function (player) {
            this.passportInfo = player || null;
            this.openModal = true;
        }),

        close: action(function () {
            this.openModal = false;
            this.passportInfo = null;
        }),

        setPassportCache: action(function (id, data) {
            this.passportCache[id] = data;
        }),

        setLoading: action(function (value) {
            this.passportLoading = value;
        }),
    });
}
